import { createApp, type App } from 'vue';
import BackstageToastContainer from '../../components/common/BackstageToastContainer.vue';
import type { ToastInstance, ToastOptions } from './types';

let toastInstance: ToastInstance | null = null;

export default {
  install(app: App) {
    if (!toastInstance) {
      const container = document.createElement('div');
      document.body.appendChild(container);

      const toastApp: App = createApp(BackstageToastContainer);

      const mountedApp = toastApp.mount(container) as InstanceType<typeof BackstageToastContainer>;

      toastInstance = {
        show(options: ToastOptions) {
          mountedApp.showToast(options);
        },
        remove(id: string) {
          mountedApp.removeToast(id);
        },
      };

      toastApp.unmount = ((originalUnmount) => {
        return function (this: App) {
          originalUnmount.call(this);
          document.body.removeChild(container);
        };
      })(toastApp.unmount);
    }

    app.config.globalProperties.$toast = toastInstance;
  },
};
